import {
  CONFIRMED_GET_SYMPTOMS,
  CONFIRMED_CREATE_SYMPTOM_ACTION,
  CONFIRMED_DELETE_SYMPTOM_ACTION,
  CONFIRMED_EDIT_SYMPTOM_ACTION,
} from "../actions/SymptomTypes";

const initialState = {
  symptoms: [],
  num_rows: 0,
};

export default function SymptomReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_SYMPTOMS:
      return {
        ...state,
        // symptoms: action.payload,
        symptoms: action.payload.symptoms || [],
        num_rows: action.payload.num_rows || 0,
      };

    case CONFIRMED_CREATE_SYMPTOM_ACTION:
      return {
        ...state,
        symptoms: [...state.symptoms, action.payload],
      };

    case CONFIRMED_DELETE_SYMPTOM_ACTION:
      return {
        ...state,
        symptoms: state.symptoms.filter(
          symptom => symptom.symptom_id !== action.payload.symptom_id
        ),
      };

    case CONFIRMED_EDIT_SYMPTOM_ACTION:
      return {
        ...state,
        symptoms: state.symptoms.map(symptom =>
          symptom.symptom_id === action.payload.symptom_id 
            ? action.payload 
            : symptom
        ),
      };

    default:
      return state;
  }
}